import { CheckboxElement } from 'react-hook-form-mui';

interface IProps {
    name: string
    disabled?: boolean
    value?: boolean | string | number
    required?: boolean;
    label: string;
    greyedOut?: boolean;
}
export default function ValidatedCheckBoxElement(props: IProps) {
    const sharedProps = {
        name: props.name,
        fullWidth: true,
        size: "small" as const,
        required: props.required,
        disabled: props.greyedOut,
    };

    const handleClick = (event: any) => {
        if (props.disabled || props.greyedOut) {
            event.preventDefault();
        }
    }

    return (
        <CheckboxElement {...sharedProps} value={props.value} label={props.label} onClick={handleClick} />
    );
}
